import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Modal, { destroyFns } from './Modal';
import Button from '../../wui-button/src';
import ConfirmModal from './ConfirmModal';
import Icon from '../../wui-icon/src';
import { prefix } from "../../wui-core/src/index.js";
var IS_REACT_16 = !!ReactDOM.createPortal;

var ConfirmDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfirmDialog, _React$Component);

  var _super = _createSuper(ConfirmDialog);

  function ConfirmDialog(props) {
    _classCallCheck(this, ConfirmDialog);

    return _super.call(this, props);
  }

  _createClass(ConfirmDialog, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var onCancel = props.onCancel,
          onOk = props.onOk,
          close = props.close,
          onHide = props.onHide,
          show = props.show,
          keyboard = props.keyboard,
          centered = props.centered,
          getContainer = props.getContainer,
          backdropStyle = props.backdropStyle,
          okButtonProps = props.okButtonProps,
          cancelButtonProps = props.cancelButtonProps,
          _props$iconType = props.iconType,
          iconType = _props$iconType === void 0 ? 'uf-qm-c' : _props$iconType,
          _props$locale = props.locale,
          locale = _props$locale === void 0 ? {
        'ok': '确定',
        'gotit': '知道了',
        'cancel': '取消'
      } : _props$locale; // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon

      var icon = props.icon === undefined ? iconType : props.icon;
      var okType = props.okType || 'primary';
      var prefixCls = props.prefixCls || "".concat(prefix, "-modal");
      var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

      var okCancel = 'okCancel' in props ? props.okCancel : true;
      var width = props.width || 400;
      var style = props.style || {};
      var backdrop = props.backdrop === undefined ? true : props.backdrop; // 默认为 false，保持旧版默认行为

      var backdropClosable = props.backdropClosable === undefined ? true : props.backdropClosable; // const runtimeLocale = getConfirmLocale();

      var okText = props.okText || (okCancel ? locale.ok : locale.gotit);
      var cancelText = props.cancelText || locale.cancel;
      var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
      var transitionName = props.transitionName || 'zoom';
      var maskTransitionName = props.maskTransitionName || 'fade';
      var classString = classNames(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
      var cancelButton = okCancel && /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          close();
          onCancel ? onCancel() : function () {
            return;
          };
        },
        colors: "secondary",
        style: {
          marginRight: 8
        }
      }, cancelText);
      var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(Icon, {
        type: icon
      }) : icon;
      return /*#__PURE__*/React.createElement(Modal, {
        width: width,
        className: classString,
        show: show,
        onHide: function onHide() {
          close();
          onCancel ? onCancel() : function () {
            return;
          };
        },
        backdrop: backdrop,
        backdropClosable: backdropClosable,
        centered: centered,
        keyboard: keyboard,
        header: null,
        backdropStyle: backdropStyle
      }, /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(contentPrefixCls, "-content")
      }, props.content)), /*#__PURE__*/React.createElement(Modal.Footer, null, cancelButton, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          close();
          onOk ? onOk() : function () {
            return;
          };
        },
        colors: okType
      }, okText)));
    }
  }]);

  return ConfirmDialog;
}(React.Component);

export default function confirm(config) {
  var div = document.createElement('div');
  document.body.appendChild(div);

  var currentConfig = _objectSpread(_objectSpread({}, config), {}, {
    close: close,
    show: true
  });

  function close() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    currentConfig = _objectSpread(_objectSpread({}, currentConfig), {}, {
      show: false,
      onHide: destroy.bind.apply(destroy, [this].concat(args))
    });

    if (IS_REACT_16) {
      render(currentConfig);
    } else {
      destroy.apply(void 0, args);
    }
  }

  function update(newConfig) {
    currentConfig = _objectSpread(_objectSpread({}, currentConfig), newConfig);
    render(currentConfig);
  }

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }

    for (var i = 0; i < destroyFns.length; i++) {
      var fn = destroyFns[i];

      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }
  }

  function render(props) {
    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmModal, props), div);
  }

  render(currentConfig);
  destroyFns.push(close);
  return {
    destroy: close,
    update: update
  };
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-modal/src/confirm.js